// @ts-nocheck
export const localeCodes =  [
  "en",
  "de",
  "da",
  "es",
  "fr",
  "it",
  "nl",
  "pt",
  "pl",
  "sl",
  "sv",
  "fi",
  "et"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_bb641efa",
      load: () => import("#nuxt-i18n/bb641efa" /* webpackChunkName: "locale_en_46json_bb641efa" */),
      cache: true
    },
    {
      key: "locale_en_46json_a21606ef",
      load: () => import("#nuxt-i18n/a21606ef" /* webpackChunkName: "locale_en_46json_a21606ef" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_d8c8b241",
      load: () => import("#nuxt-i18n/d8c8b241" /* webpackChunkName: "locale_de_46json_d8c8b241" */),
      cache: true
    },
    {
      key: "locale_de_46json_155fd3c4",
      load: () => import("#nuxt-i18n/155fd3c4" /* webpackChunkName: "locale_de_46json_155fd3c4" */),
      cache: true
    }
  ],
  da: [
    {
      key: "locale_da_46json_c13422e0",
      load: () => import("#nuxt-i18n/c13422e0" /* webpackChunkName: "locale_da_46json_c13422e0" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_eb6d4b32",
      load: () => import("#nuxt-i18n/eb6d4b32" /* webpackChunkName: "locale_es_46json_eb6d4b32" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_9de7e2d5",
      load: () => import("#nuxt-i18n/9de7e2d5" /* webpackChunkName: "locale_fr_46json_9de7e2d5" */),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_46json_936359c7",
      load: () => import("#nuxt-i18n/936359c7" /* webpackChunkName: "locale_it_46json_936359c7" */),
      cache: true
    }
  ],
  nl: [
    {
      key: "locale_nl_46json_d2a2a170",
      load: () => import("#nuxt-i18n/d2a2a170" /* webpackChunkName: "locale_nl_46json_d2a2a170" */),
      cache: true
    }
  ],
  pt: [
    {
      key: "locale_pt_46json_48f59ea3",
      load: () => import("#nuxt-i18n/48f59ea3" /* webpackChunkName: "locale_pt_46json_48f59ea3" */),
      cache: true
    }
  ],
  pl: [
    {
      key: "locale_pl_46json_7c2d5897",
      load: () => import("#nuxt-i18n/7c2d5897" /* webpackChunkName: "locale_pl_46json_7c2d5897" */),
      cache: true
    }
  ],
  sl: [
    {
      key: "locale_sl_46json_1c206a00",
      load: () => import("#nuxt-i18n/1c206a00" /* webpackChunkName: "locale_sl_46json_1c206a00" */),
      cache: true
    }
  ],
  sv: [
    {
      key: "locale_sv_46json_87ff3857",
      load: () => import("#nuxt-i18n/87ff3857" /* webpackChunkName: "locale_sv_46json_87ff3857" */),
      cache: true
    }
  ],
  fi: [
    {
      key: "locale_fi_46json_7dc078a2",
      load: () => import("#nuxt-i18n/7dc078a2" /* webpackChunkName: "locale_fi_46json_7dc078a2" */),
      cache: true
    }
  ],
  et: [
    {
      key: "locale_et_46json_5a9d92ae",
      load: () => import("#nuxt-i18n/5a9d92ae" /* webpackChunkName: "locale_et_46json_5a9d92ae" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "en",
    iso: "en",
    name: "English",
    label: "EN",
    language: "en",
    _hreflang: "en",
    _sitemap: "en"
  },
  {
    code: "de",
    iso: "de",
    name: "German",
    label: "DE",
    language: "de",
    _hreflang: "de",
    _sitemap: "de"
  },
  {
    code: "da",
    iso: "da",
    name: "Danish",
    label: "DA",
    language: "da",
    _hreflang: "da",
    _sitemap: "da"
  },
  {
    code: "es",
    iso: "es",
    name: "Spanish",
    label: "ES",
    language: "es",
    _hreflang: "es",
    _sitemap: "es"
  },
  {
    code: "fr",
    iso: "fr",
    name: "French",
    label: "FR",
    language: "fr",
    _hreflang: "fr",
    _sitemap: "fr"
  },
  {
    code: "it",
    iso: "it",
    name: "Italian",
    label: "IT",
    language: "it",
    _hreflang: "it",
    _sitemap: "it"
  },
  {
    code: "nl",
    iso: "nl",
    name: "Dutch",
    label: "NL",
    language: "nl",
    _hreflang: "nl",
    _sitemap: "nl"
  },
  {
    code: "pt",
    iso: "pt",
    name: "Portuguese",
    label: "PT",
    language: "pt",
    _hreflang: "pt",
    _sitemap: "pt"
  },
  {
    code: "pl",
    iso: "pl",
    name: "Polish",
    label: "PL",
    language: "pl",
    _hreflang: "pl",
    _sitemap: "pl"
  },
  {
    code: "sl",
    iso: "sl",
    name: "Slovenian",
    label: "SL",
    language: "sl",
    _hreflang: "sl",
    _sitemap: "sl"
  },
  {
    code: "sv",
    iso: "sv",
    name: "Swedish",
    label: "SV",
    language: "sv",
    _hreflang: "sv",
    _sitemap: "sv"
  },
  {
    code: "fi",
    iso: "fi",
    name: "Finnish",
    label: "FI",
    language: "fi",
    _hreflang: "fi",
    _sitemap: "fi"
  },
  {
    code: "et",
    iso: "et",
    name: "Eesti",
    label: "ET",
    language: "et",
    _hreflang: "et",
    _sitemap: "et"
  }
]
/** client **/

/** client-end **/